var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g({staticClass:"date-input",attrs:{"id":"input-talk-feedbacks-filter-date","placeholder":_vm.placeholder,"value":_vm.inputValue,"readonly":"","state":_vm.state,"autocomplete":"off"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},_vm.inputEvents))
}
var staticRenderFns = []

export { render, staticRenderFns }